import { useAppInit } from 'app/lib/hooks/useAppInit';
import { PreloaderContainer } from 'app/routers/styles';
import { ContactBook } from 'pages/contactBook';
import { HallmapEditor } from 'pages/hallmapEditor';
import { HallmapGameLab } from 'pages/hallmapGameLab';
import { LoginPage } from 'pages/login/ui';
import { WaitingList } from 'pages/waitingList';
import { lazy, ReactNode, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Preloader } from 'shared/ui/spinner';

const HomePage = lazy(() =>
	import('pages/homePage').then(module => ({
		default: module.HomePage,
	})),
);

const Bookings = lazy(() =>
	import('pages/bookings').then(module => ({
		default: module.Bookings,
	})),
);

const Applications = lazy(() =>
	import('pages/applications').then(module => ({
		default: module.Applications,
	})),
);

const AppInit = ({ children }: { children: ReactNode }) => {
	const isInit = useAppInit();

	if (!isInit && window.location.pathname !== '/login') {
		return (
			<PreloaderContainer>
				<Preloader
					$borderColor={'#0c21634d'}
					$borderTopColor={'#7694f3'}
					$width="15px"
					$height="15px"
				/>
			</PreloaderContainer>
		)
	}

	return <>{children}</>;
};

export const AppRouter = () => {
	return (
		<BrowserRouter>
			<AppInit>
				<Routes>
					<Route
						path="/"
						element={
							<Suspense
								fallback={
									<PreloaderContainer>
										<Preloader />
									</PreloaderContainer>
								}
							>
								<HomePage />
							</Suspense>
						}
					/>
					<Route
						path="/bookings"
						element={
							<Suspense
								fallback={
									<PreloaderContainer>
										<Preloader />
									</PreloaderContainer>
								}
							>
								<Bookings />
							</Suspense>
						}
					/>
					<Route
						path="/applications"
						element={
							<Suspense
								fallback={
									<PreloaderContainer>
										<Preloader />
									</PreloaderContainer>
								}
							>
								<Applications />
							</Suspense>
						}
					/>
					<Route
						path="/waiting-list"
						element={
							<Suspense
								fallback={
									<PreloaderContainer>
										<Preloader />
									</PreloaderContainer>
								}
							>
								<WaitingList />
							</Suspense>
						}
					/>
					<Route
						path="/contact-book"
						element={
							<Suspense
								fallback={
									<PreloaderContainer>
										<Preloader />
									</PreloaderContainer>
								}
							>
								<ContactBook />
							</Suspense>
						}
					/>
					<Route
						path="/hallmap-lab"
						element={
							<Suspense
								fallback={
									<PreloaderContainer>
										<Preloader />
									</PreloaderContainer>
								}
							>
								<HallmapGameLab />
							</Suspense>
						}
					/>
					<Route
						path="/preferences/editor"
						element={
							<Suspense
								fallback={
									<PreloaderContainer>
										<Preloader />
									</PreloaderContainer>
								}
							>
								<HallmapEditor />
							</Suspense>
						}
					/>
					<Route
						path='/login'
						element={
							<LoginPage />
						}
					/>
				</Routes>

			</AppInit>
		</BrowserRouter>
	);
};
